import React from "react";
import PropTypes from "prop-types";
import Table from "../../../common/components/Table/Table";
import {Link} from "react-router-dom";
import {countriesListFormatter} from "../../../common/utils/CountriesListFormatter";

export default class AssociatedServicesTable extends React.Component {

    static propTypes = {
        associatedServices: PropTypes.array,
    }

    render() {

        return(
            <div className="associated-services-table">
                <h2>Data Services</h2>
                <Table>
                    {this.props.associatedServices.map(service => {
                        const serviceID = service.service_id;
                        const associatedCountries = service.associated_countries;

                        const formattedCost = service.cost
                            ? parseFloat(service.cost).toFixed(3)
                            : "";
                        const formattedPricingModel = service.price_model
                            ? service.price_model.charAt(0).toUpperCase() + service.price_model.slice(1)
                            : ""
                        const pricingModel = service.price_model && service.cost
                            ? ` ${formattedCost} Per  ${formattedPricingModel}`
                            : "";
                        const serviceType = service.service_type;

                        const countriesList = countriesListFormatter(associatedCountries);

                        return (
                            <tr key={serviceID}>
                                <td>
                                    <Link to={{pathname: `/veritas/${serviceType}-services/` + serviceID}}
                                          key={serviceID}
                                    >
                                        <span>{service.service_name}</span>
                                        <p>{"Primary Service Config Name: "} {service.primary_service_config_name}</p>
                                    </Link>
                                </td>
                                <td>
                                    <p>{countriesList}</p>
                                    <p>{service.currency_symbol} {pricingModel}</p>
                                </td>
                            </tr>
                        );
                    })}
                </Table>
            </div>
        );
    }
}
